import { render, staticRenderFns } from "./Leave.vue?vue&type=template&id=6dff09d6&scoped=true"
import script from "./Leave.vue?vue&type=script&lang=js"
export * from "./Leave.vue?vue&type=script&lang=js"
import style0 from "./Leave.vue?vue&type=style&index=0&id=6dff09d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dff09d6",
  null
  
)

export default component.exports